import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { getContactSettings, saveContactSettings } from 'redux/actions/contactSettings.actions';

import LayoutContainer from 'containers/LayoutContainer';
import ContactSettingsView from 'views/ContactSettingsView';
import Loading from 'components/commons/Loading';

import { IContactSettingsFormData } from 'views/ContactSettingsView/types';
import 'views/ContactSettingsView/i18n';

const ContactSettingsContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { item, loading } = useTypedSelector((state) => state.contactSettings);
  const whatsappNumber = item?.whatsappNumber || '';

  useEffect(() => {
    dispatch(getContactSettings());
  }, [dispatch]);

  const onSubmit = (values: IContactSettingsFormData) => dispatch(saveContactSettings(values));

  return (
    <LayoutContainer auth title={i18next.t<string>('CONTACT_SETTINGS_VIEW:TITLE')}>
      <ContactSettingsView initialValues={{ whatsappNumber }} onSubmit={onSubmit} />
      {loading && (
        <Loading isModalMode message={i18next.t<string>('CONTACT_SETTINGS_VIEW:LOADING')} />
      )}
    </LayoutContainer>
  );
};

export default ContactSettingsContainer;
